import environment from "../../environment";
import { GET } from "../http.service";



// export const getTranslations = async () => {
//   const response = await GETWithParams(
//     `Localization/key-value`,
//     { platform: "FrontEnd" },
//     false
//   );
//   return response;
// };
const languageEndpoint = environment.Language;
export const getAllLanguages = async () => {
  const response = await GET(languageEndpoint, false);
  return response;
};
